import { render, staticRenderFns } from "./MetaAdsDashboard.vue?vue&type=template&id=91c183ac&scoped=true"
import script from "./MetaAdsDashboard.vue?vue&type=script&lang=js"
export * from "./MetaAdsDashboard.vue?vue&type=script&lang=js"
import style0 from "./MetaAdsDashboard.vue?vue&type=style&index=0&id=91c183ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c183ac",
  null
  
)

export default component.exports